import { Component, OnInit, AfterViewInit, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { NbWindowRef, NbWindowConfig, NbWindowState } from '@nebular/theme';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-window-form',
  templateUrl: 'window-form.component.html',
  styleUrls: ['window-form.component.scss'],
})
export class WindowFormComponent implements OnInit, AfterViewInit {
  logoutSubscriber: Subscription;
  windowState: Subscription;
  roomId: any;
  @ViewChild('archiveButton', { static: false }) archiveButton: ElementRef;
  private buttonMoved: boolean = false;

  constructor(
    protected windowRef: NbWindowRef,
    public config: NbWindowConfig,
    public authService: AuthenticationService,
    public chatService: ChatService,
    private renderer: Renderer2,
    private hostElement: ElementRef
  ) {
  }

  ngOnInit() {
    this.roomId = this.config.context;
    this.closeOnLogout();
    this.setWindowState();
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.moveButtonToHeader(), 100);
  }

  moveButtonToHeader(): void {
    if (!this.archiveButton?.nativeElement) {
      setTimeout(() => this.moveButtonToHeader(), 100);
      return;
    }

    // Find the window header buttons container
    const windowElement = this.hostElement.nativeElement.closest('nb-window');
    if (!windowElement) {
      setTimeout(() => this.moveButtonToHeader(), 100);
      return;
    }

    const headerButtons = windowElement.querySelector('nb-card-header .buttons');
    if (!headerButtons) {
      setTimeout(() => this.moveButtonToHeader(), 100);
      return;
    }

    const button = this.archiveButton.nativeElement;

    // Check if button is already in header
    const existingButtonInHeader = headerButtons.querySelector('.archive-menu-button');
    if (existingButtonInHeader && existingButtonInHeader === button) {
      // Button already correctly placed in header
      return;
    }

    if (existingButtonInHeader && existingButtonInHeader !== button) {
      this.renderer.removeChild(headerButtons, existingButtonInHeader);
    }

    // Hide any duplicate buttons in template (keep only one)
    const templateButtons = this.hostElement.nativeElement.querySelectorAll('.archive-menu-button');
    templateButtons.forEach((btn: HTMLElement, index: number) => {
      if (index > 0 || btn !== button) {
        this.renderer.setStyle(btn, 'display', 'none');
      }
    });

    const isInTemplate = button.parentElement === this.hostElement.nativeElement ||
      button.parentElement?.closest('app-window-form') === this.hostElement.nativeElement;

    if (!isInTemplate && button.parentElement !== headerButtons) {
      return;
    }

    if (isInTemplate) {
      const firstControlButton = headerButtons.querySelector('nb-icon-button, button:not(.archive-menu-button)');
      if (firstControlButton) {
        this.renderer.insertBefore(headerButtons, button, firstControlButton);
      } else {
        this.renderer.appendChild(headerButtons, button);
      }
      this.buttonMoved = true;
    }
  }

  async archiveChat() {
    let response = await this.chatService.archiveRoom(this.roomId);
    if (response && response.success === true) {
      let data = { roomId: this.roomId, state: 'archived' }
      this.chatService.windowStateChange(data);
    }
  }

  setWindowState() {
    this.windowState = this.windowRef.stateChange.subscribe(async (state) => {
      let data = { roomId: this.roomId, state: state }
      this.chatService.windowStateChange(data);

      // Re-move button to header after state change (window might be recreated)
      setTimeout(() => {
        this.buttonMoved = false; // Reset flag to allow re-move
        this.moveButtonToHeader();
      }, 200);
    })
  }

  close() {
    this.windowRef.close();
  }

  closeOnLogout() {
    this.logoutSubscriber = this.authService.closeChatWindowListner().subscribe(async () => {
      this.close();
    });
  }

  ngOnDestroy(): void {
    if (this.windowRef.state === NbWindowState.MAXIMIZED) {
      this.logoutSubscriber.unsubscribe();
    };
    this.windowState.unsubscribe();
  }

}
